import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import { styled, useTheme } from 'styled-components';
import Loader from '../../Loader/index.js';

var _templateObject;
var StyledLoader = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  margin-top: ", ";\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.sizing.xtiny;
});
var LoadingIndicator = function LoadingIndicator() {
  var theme = useTheme();
  return React__default.createElement(StyledLoader, null, React__default.createElement(Loader, {
    size: theme.sizing.medium,
    colour: "currentColor"
  }));
};

export { LoadingIndicator, LoadingIndicator as default };
//# sourceMappingURL=LoadingIndicator.js.map
